var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner copy-charge-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.title,
            width: "1160px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "80px", "label-position": "left" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("line-label", {
                                attrs: {
                                  slot: "label",
                                  label: _vm.$t("CargoMsg.Cargo_BusinessNo")
                                },
                                slot: "label"
                              }),
                              _c("el-input", {
                                model: {
                                  value: _vm.form.jobNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "jobNo", $$v)
                                  },
                                  expression: "form.jobNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_AuthorizedClient")
                              }
                            },
                            [
                              _c("cargo-sales-company-select", {
                                attrs: {
                                  "options-width": "150px;",
                                  "method-params": { customer: true },
                                  "default-value":
                                    _vm.form.customer == 0
                                      ? ""
                                      : _vm.form.customer
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.customer = p.cmpIdx)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("line-label", {
                                attrs: {
                                  slot: "label",
                                  label: _vm.$t("CargoMsg.Cargo_FLCLType")
                                },
                                slot: "label"
                              }),
                              _c(
                                "el-select",
                                {
                                  model: {
                                    value: _vm.form.containerLoadType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "containerLoadType",
                                        $$v
                                      )
                                    },
                                    expression: "form.containerLoadType"
                                  }
                                },
                                _vm._l(_vm.containerLoadTypes, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm.isZh
                                        ? item.chineseName
                                        : item.englishName,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("line-label", {
                                attrs: {
                                  slot: "label",
                                  label: _vm.$t("CargoMsg.Cargo_CargoType")
                                },
                                slot: "label"
                              }),
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CargoType,
                                  "callback-method-type": "value",
                                  "default-value": _vm.form.cargoType,
                                  "callback-params": { key: "cargoType" },
                                  "options-width": "150px;"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.cargoType = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_MblNo") }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.mblNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "mblNo", $$v)
                                  },
                                  expression: "form.mblNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("line-label", {
                                attrs: {
                                  slot: "label",
                                  label: _vm.$t("CargoMsg.Cargo_BookingAgent")
                                },
                                slot: "label"
                              }),
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  "options-width": "150px;",
                                  "method-params": { bookingAgent: true },
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "default-value":
                                    _vm.form.bookingAgent == 0
                                      ? ""
                                      : _vm.form.bookingAgent
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.bookingAgent = p.cmpIdx)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.PortOfLoading")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isSea,
                                    expression: "isSea"
                                  }
                                ],
                                attrs: {
                                  "options-width": "150px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  "default-value": _vm.form.txtSeaLoadingPort,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.txtSeaLoadingPort = p.code
                                  }
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isSea,
                                    expression: "!isSea"
                                  }
                                ],
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Airport,
                                  filterable: "",
                                  "options-width": "150px;",
                                  "default-value": _vm.form.txtAirLoadingPort,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.txtAirLoadingPort = p.code
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_DestinationPort")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isSea,
                                    expression: "isSea"
                                  }
                                ],
                                attrs: {
                                  "options-width": "150px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  "default-value":
                                    _vm.form.txtSeaDestinationPort,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.txtSeaDestinationPort = p.code
                                  }
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isSea,
                                    expression: "!isSea"
                                  }
                                ],
                                attrs: {
                                  "options-width": "150px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Airport,
                                  filterable: "",
                                  "default-value":
                                    _vm.form.txtAirDestinationPort,
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.txtAirDestinationPort = p.code
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Carrier") }
                            },
                            [
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isSea,
                                    expression: "isSea"
                                  }
                                ],
                                attrs: {
                                  filterable: "",
                                  "options-width": "150px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { seaCmp: true },
                                  "default-value":
                                    _vm.form.seCarrier == 0
                                      ? ""
                                      : _vm.form.seCarrier
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.seCarrier = p.cmpIdx)
                                  }
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isSea,
                                    expression: "!isSea"
                                  }
                                ],
                                attrs: {
                                  filterable: "",
                                  "options-width": "150px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { seaCmp: true },
                                  "default-value":
                                    _vm.form.aiCarrier == 0
                                      ? ""
                                      : _vm.form.aiCarrier
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.aiCarrier = p.cmpIdx)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "FinanceManage.charge_chargeItem"
                                ),
                                "label-position": "right"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  "options-width": "150px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_ChargeItem,
                                  "default-value":
                                    _vm.form.chargeItemId == 0
                                      ? ""
                                      : _vm.form.chargeItemId
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.chargeItemId = p.itemId)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Airline") }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Region,
                                  "callback-params": { key: "txtServiceLine" },
                                  "callback-method-type": "value",
                                  "options-width": "150px;",
                                  "default-value": _vm.form.txtServiceLine
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.txtServiceLine = p.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("line-label", {
                                attrs: {
                                  slot: "label",
                                  label: _vm.$t(
                                    "CargoMsg.Cargo_DestinationAgent"
                                  )
                                },
                                slot: "label"
                              }),
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  "tag-name": "englishName",
                                  "options-width": "150px;",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { overseaAgent: true },
                                  "default-value": _vm.form.txtDestAgent
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.form.txtDestAgent = p.cmpIdx)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("line-label", {
                                attrs: {
                                  slot: "label",
                                  label: _vm.$t(
                                    "CargoMsg.Cargo_PaymentReceiveMethod"
                                  )
                                },
                                slot: "label"
                              }),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    disabled: _vm.receivableDisable
                                  },
                                  model: {
                                    value: _vm.form.receivable,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "receivable", $$v)
                                    },
                                    expression: "form.receivable"
                                  }
                                },
                                _vm._l(_vm.CHANGE_CHARGE_CHARGETYPE, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.chineseName,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_SettleAccountsTo")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": { active: true },
                                  "default-value": _vm.form.accountId
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.accountId = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.isSeaOrRailwayOrIntegrated
                        ? [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  [
                                    _c("line-label", {
                                      attrs: {
                                        slot: "label",
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_ContainerSize"
                                        )
                                      },
                                      slot: "label"
                                    }),
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          filterable: "",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.form.eqSize,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "eqSize", $$v)
                                          },
                                          expression: "form.eqSize"
                                        }
                                      },
                                      _vm._l(_vm.SEA_EXPORT_BOX_TYPES, function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.chineseName,
                                            value: item.code,
                                            "default-value": _vm.form.eqSize
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_ContainerType"
                                      )
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        filterable: "",
                                        "select-type":
                                          _vm.selectTypeNames.basic_data_EQType,
                                        "tag-name": "code",
                                        "method-params": { active: true },
                                        "default-value": _vm.form.eqType
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.eqType = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _vm.isSeaOrAir
                        ? [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_MBLFreightTerm"
                                      )
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        filterable: "",
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_PaymentTerm,
                                        "method-params": { active: true },
                                        "default-value": _vm.form.paymentTermMBL
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.paymentTermMBL = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm.isZY
                        ? [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "SeaExport.AllowSaleProduct"
                                      )
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_AllowSaleProduct,
                                        filterable: "",
                                        no: "allowSaleProduct",
                                        "method-params": {
                                          saleProductCode: true
                                        },
                                        "data-filter-function": function(p) {
                                          return p.statusEnabled
                                        },
                                        "default-value":
                                          _vm.form.saleProductCode || ""
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.saleProductCode = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.FullOrInside")
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames
                                            .local_cache_FullOrInside$FULL_OR_INSIDE,
                                        no: "fullOrInside",
                                        "method-params": { fullOrInside: true },
                                        "default-value":
                                          _vm.form.fullOrInside || ""
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.fullOrInside = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c("line-label", {
                                attrs: {
                                  slot: "label",
                                  label: _vm.$t("SeaExport.ItemNo")
                                },
                                slot: "label"
                              }),
                              _c("el-input", {
                                model: {
                                  value: _vm.form.poNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "poNo", $$v)
                                  },
                                  expression: "form.poNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { staticClass: "custom" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.toQuery(1)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.resetHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ResetFilter"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { "min-height": "350px", padding: "0" }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", height: "400px" },
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "deselect-sub-record": true
                },
                on: { gridReady: _vm.onGridReady }
              })
            ],
            1
          ),
          _c("cargo-pagination", {
            attrs: {
              "page-sizes": [5, 10, 20, 30, 50, 500],
              "config-module": "9300001",
              total: _vm.searchConditions.total,
              page: _vm.searchConditions.pageNum,
              limit: _vm.searchConditions.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.searchConditions, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.searchConditions, "pageSize", $event)
              },
              pagination: _vm.fetchDataByPage
            }
          }),
          _c(
            "span",
            {
              staticStyle: { padding: "10px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.selectHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }